var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDropdownColor33(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "6px",
    viewBox: "0 0 11 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDropdownColor33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.947396,8.47465906 L71.9654283,12.8246648 C71.7641168,13.0445828 71.4226428,13.0596663 71.2027248,12.8583547 C71.1910045,12.847626 71.1797635,12.8363851 71.1690348,12.8246648 C70.9436551,12.578454 70.9436551,12.2008744 71.1690348,11.9546636 L74.789,8 L71.1690348,4.04533637 C70.9436551,3.79912562 70.9436551,3.42154598 71.1690348,3.17533523 C71.3703464,2.95541723 71.7118204,2.94033371 71.9317384,3.14164526 L71.9654283,3.17533523 L71.9654283,3.17533523 L75.947396,7.52534094 C76.0475648,7.63476794 76.1032141,7.77014435 76.1143439,7.90840403 L76.1143439,8.09159597 C76.1032141,8.22985565 76.0475648,8.36523206 75.947396,8.47465906 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-Articles-Desktop",
    transform: "translate(-954.000000, -228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(123.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hot-Topic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(747.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icDropdownColor33",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(73.558215, 8.000000) scale(-1, 1) rotate(90.000000) translate(-73.558215, -8.000000) ",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdownColor33);
export default __webpack_public_path__ + "static/media/icDropdownColor33.63ae9e7d0645abf41335d4a4e86f0dc8.svg";
export { ForwardRef as ReactComponent };